module.exports = __webpack_public_path__ + "static/media/profile_communication.0b34e7c6.webp";